import React, { useState, useEffect } from "react";

import { addDays } from "date-fns";

import { connect } from "react-redux";
import { Actions as ACTIONS } from "../../../store/actions/workLocationActions";
import { CheckCircleIcon, MapPinIcon, PlusIcon, TrashIcon } from "@heroicons/react/20/solid";
import NoItemsRow from "../../common/NoItemsRow";
import LoadingContent from "../../common/LoadingContent";
import Spinner from "../../common/Spinner";
import { NotificationManager } from "react-notifications";
import Tooltip from "@/tooltip";
import UpgradeRequired from "../../company-pages/UpgradeRequired";
import WorkLocationPinModal from "./modals/WorkLocationPinModal";

const WorkLocationSettings = ({
  org,
  loading,
  workLocationTypes,
  toggleWorkLocationPermissions,
  addWorkLocation,
  disabled,
  setWorkLocationName,
  getWorkLocationSettings,
  saving,
  saveWorkLocationSettings,
  deleteWorkLocation,
  includedInPlan,
  isDemo,
  setWorkLocationPinModal,
}) => {
  useEffect(() => {
    getWorkLocationSettings();
  }, []);

  if (!includedInPlan && !isDemo) return <UpgradeRequired />;
  if (!org || loading) return <LoadingContent />;

  const saveSettings = () => {
    if (workLocationTypes.find(item => !item.name?.replace(/\s/g, ''))) {
      NotificationManager.error('Work Location Names are Required', 'Saving Work Locations')
      return
    }

    if (workLocationTypes.filter(I => I.defaultLocation).length == 0) {
      NotificationManager.error('Default Work Location is Required', 'Saving Work Locations')
      return
    }
    saveWorkLocationSettings()
  }

  return (
    <form onSubmit={(e) => {
      e.preventDefault()
      e.stopPropagation()
    }}
    className="px-8">
      <WorkLocationPinModal />
      <div className="col-xs-12 form-section">
        <div className='col-xs-3'>
          <h4>Work Locations</h4>
        </div>
        <div className="col-xs-9">
          <button
            id="t-worklocation-add-location"
            type="button"
            className="btn btn-success pull-right"
            disabled={disabled}
            onClick={() => addWorkLocation()}>
            <PlusIcon style={{ height: "1.5em", float: "left", marginRight: 5 }} />
            <div style={{ float: "left" }}>Add Work Location</div>
          </button>
        </div>
        <div style={{ width: '100%', overflow: 'auto' }}>
          <table id="table-timesheets" className="table table-hover" style={{ paddingLeft: 10 }}>
            {workLocationTypes?.length > 0 ?
              <>
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Manager can Apply/Approve</th>
                    <th>Employee can Apply</th>
                    <th>Default Location</th>
                    {/* <th>Show Country Selection</th> */}
                    <th width="5%"></th>
                  </tr>
                </thead>
                <tbody>
                  {workLocationTypes?.map((workLocationType) => (
                    <tr key={workLocationType.id}>
                      <td>
                        <div className="form-material">
                          <input
                            className="form-control"
                            disabled={disabled}
                            value={workLocationType.name}
                            onChange={(e) => {
                              if (!disabled) setWorkLocationName(workLocationType.id, e.target.value);
                            }}
                            style={{ maxWidth: 150 }}
                          />
                        </div>
                      </td>
                      <td>
                        <label
                          className="css-input switch switch-sm switch-success"
                          onClick={(e) => {
                            if (!disabled) {
                              e.stopPropagation();
                              e.preventDefault();
                              toggleWorkLocationPermissions(workLocationType.id, "managerCanApprove");
                            }
                          }}>
                          <input name="mode" disabled={disabled} type="checkbox" checked={workLocationType.managerCanApprove} />
                          <span></span>
                        </label>
                      </td>
                      <td>
                        <label
                          className="css-input switch switch-sm switch-success"
                          onClick={(e) => {
                            if (!disabled) {
                              e.stopPropagation();
                              e.preventDefault();
                              toggleWorkLocationPermissions(workLocationType.id, "employeeCanApply");
                            }
                          }}>
                          <input name="mode" disabled={disabled} type="checkbox" checked={workLocationType.employeeCanApply} />
                          <span></span>
                        </label>
                      </td>
                      <td>
                        <label
                          className="css-input switch switch-sm switch-success"
                          onClick={(e) => {
                            if (!disabled) {
                              e.stopPropagation();
                              e.preventDefault();
                              toggleWorkLocationPermissions(workLocationType.id, "defaultLocation");
                            }
                          }}>
                          <input name="mode" disabled={disabled} type="checkbox" style={{ width: 20 }} checked={workLocationType.defaultLocation} />
                          <span></span>
                        </label>
                      </td>
                      {/* <td>
							<label
                className="css-input switch switch-sm switch-success"
								onClick={(e) => {
									if (!disabled) {
										e.stopPropagation();
										e.preventDefault();
										toggleWorkLocationPermissions(workLocationType.id, "showBalance");
									}
								}}>
								<input name="mode" disabled={disabled} type="checkbox" checked={workLocationType.showCountry} />
								<span></span>
							</label>
						</td> */}
                      <td>
                        <div
                          className="btn-group"
                          style={{ marginTop: 7 }}
                        >
                          <div
                            className="btn btn-xs btn-default"
                            onClick={() => {
                              setWorkLocationPinModal(workLocationType.id, true);
                            }}>
                            <Tooltip content="Pin Work Location">
                              <MapPinIcon className="h-5 w-5" style={{ marginTop: "3px" }} />
                            </Tooltip>
                          </div>
                          {workLocationType.newEntry &&
                            <div
                              className="btn btn-xs btn-danger"
                              onClick={() => {
                                deleteWorkLocation(workLocationType.id)
                              }}
                            >
                              <Tooltip content="Delete Work Location">
                                <TrashIcon className="h-5 w-5" style={{ marginTop: "3px" }} />
                              </Tooltip>
                            </div>
                          }
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </>
              :
              <NoItemsRow name='Work Locations' />
            }

          </table>
        </div>
      </div>
      {!disabled &&
        <button
          className="btn btn-success pull-right"
          onClick={() => saveSettings()}
        >
          {saving ?
            <Spinner
              style={{ height: "1.5em", float: "left", marginRight: 10 }}
              className="animate-spin -ml-1 mr-3 h-5 w-5 "
            />
            :
            <CheckCircleIcon style={{ height: "1.5em", float: "left", marginRight: 10 }} />
          }
          <span>Save</span>
        </button>
      }
    </form>
  );
};

const mapStateToProps = (state) => {
  return {
    workLocationTypes: state.workLocation.types,
    loading: state?.workLocation?.workLocationSettingsUpdating,
    org: state?.company?.settings?.org,
    isDemo: state?.company?.settings?.isDemo,
    userPermissions: state?.permissions?.my?.permissions?.settings,
    disabled: (state?.permissions?.my?.permissions?.settings == "Read") || (state?.company?.settings?.status == 'Archived'),
    saving: state.workLocation?.settingsSaving,
    includedInPlan: state.permissions?.plan?.workLocation,
  };
};

const mapDispatchToProps = (dispatch) => ({
  toggleWorkLocationPermissions: (workLocationType, permission) => dispatch(ACTIONS.toggleWorkLocationSettings(workLocationType, permission)),
  setWorkLocationName: (workLocationType, name) => dispatch(ACTIONS.setWorkLocationName(workLocationType, name)),
  addWorkLocation: () => dispatch(ACTIONS.addWorkLocation()),
  deleteWorkLocation: (id) => dispatch(ACTIONS.deleteWorkLocation(id)),
  saveWorkLocationSettings: () => dispatch(ACTIONS.saveWorkLocationSettings()),
  getWorkLocationSettings: () => dispatch(ACTIONS.getWorkLocationSettings()),
  setWorkLocationPinModal: (id) => dispatch(ACTIONS.setWorkLocationPinModal(id, true)),
});

export default connect(mapStateToProps, mapDispatchToProps)(WorkLocationSettings);
